import { BrowserRouter, Routes, Route } from "react-router";

import { HomePage } from "./pages/home/home";
import { ContactPage } from "./pages/contact/contact";
import { ServicesPage } from "./pages/services/services";
import { AboutUs } from "./pages/about/about";
import { WhatsappButton } from "./components/utils/whatsapp-button";
import { CleanerRequest } from "./pages/cleaner-request/cleaner-request";

/**css */
import "./index.css";
import "./styles/header.css";
import "./styles/footer.css";
import "./styles/home.css";
import "./styles/forms.css";

/** services */
import { RequestContextProvider } from "./services/requests/request.context";
import { SiteHeader } from "./components/header/header";
import { SiteFooter } from "./components/footer/footer";
import ScrollToTopButton from "./components/utils/scroll-to-top";

const App = () => {
  return (
    <BrowserRouter>
      <RequestContextProvider>
        <WhatsappButton />
        <SiteHeader/>
        <ScrollToTopButton />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/cleanerrequest" element={<CleanerRequest />} />
        </Routes>
        <SiteFooter />
      </RequestContextProvider>
    </BrowserRouter>
  )
}

export default App;